module.exports = "mat-container {\n  padding: 0px; }\n"